import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import HomePage from './pages/HomePage';
import MainPage from './pages/MainPage';
import AccountPage from './pages/AccountPage';
import StorePage from './pages/StorePage';
import TableOrderPage from './pages/TableOrderPage';
import TableCheckoutPage from './pages/TableCheckoutPage';
import OrderHistoryPage from './pages/OrderHistoryPage';
import OrderTrackingPage from './pages/OrderTrackingPage';
import ReviewPage from './pages/ReviewPage';
import CheckoutPage from './pages/CheckoutPage';
import ReservationBookingPage from './pages/ReservationBookingPage';
import MyReservationsPage from './pages/MyReservationsPage';
import ReservationDetailPage from './pages/ReservationDetailPage';
import QueueStatusPage from './pages/QueueStatusPage';
import ReceiptPage from './pages/ReceiptPage';
import LogoutPage from './pages/LogoutPage';
import AddressPromptModal from './components/AddressPromptModal';
import AddressModal from './components/AddressModal';
import SignupModal from './components/SignupModal';
import { MAPBOX_TOKEN } from './firebaseConfig';

function AppInner() {
  const { needsAddress, setNeedsAddress, setGuestLocation, showAddressModal, closeAddressModal, showSignupModal, closeSignupModal } = useAuth();

  const handleAddressComplete = (addressData) => {
    setGuestLocation({
      lat: addressData.lat,
      lng: addressData.lng,
      address: addressData.address,
      source: 'account',
    });
    setNeedsAddress(false);
  };

  const handleAddressSet = (addressData) => {
    setGuestLocation({
      lat: addressData.lat,
      lng: addressData.lng,
      address: addressData.address,
      source: 'account',
    });
    closeAddressModal();
  };

  return (
    <>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/explore" element={<MainPage />} />
        <Route path="/account" element={<AccountPage />} />
        <Route path="/store/:slug" element={<StorePage />} />
        <Route path="/t/:locationId/:tableId" element={<TableOrderPage />} />
        <Route path="/t/:locationId/:tableId/checkout" element={<TableCheckoutPage />} />
        <Route path="/orders" element={<OrderHistoryPage />} />
        <Route path="/order/:orderId" element={<OrderTrackingPage />} />
        <Route path="/review/:orderId" element={<ReviewPage />} />
        <Route path="/checkout/:slug" element={<CheckoutPage />} />
        <Route path="/reserve/:storeId" element={<ReservationBookingPage />} />
        <Route path="/reservations" element={<MyReservationsPage />} />
        <Route path="/reservation/:reservationId" element={<ReservationDetailPage />} />
        <Route path="/queue/:entryId" element={<QueueStatusPage />} />
        <Route path="/r/:businessId/:saleId" element={<ReceiptPage />} />
        <Route path="/logout" element={<LogoutPage />} />
      </Routes>
      {needsAddress && (
        <AddressPromptModal onComplete={handleAddressComplete} />
      )}
      {showAddressModal && (
        <AddressModal
          onClose={closeAddressModal}
          onAddressSet={handleAddressSet}
          mapboxToken={MAPBOX_TOKEN}
        />
      )}
      {showSignupModal && (
        <SignupModal
          onClose={closeSignupModal}
          onLoginClick={closeSignupModal}
        />
      )}
    </>
  );
}

function App() {
  return (
    <AuthProvider>
      <Router>
        <AppInner />
      </Router>
    </AuthProvider>
  );
}

export default App;
